export class TypeAssistancesCategories {
  static readonly assistance = 'Assistance';
  static readonly support = 'Support';
  static readonly update = 'Mise à jour';
}
